import { ExportStatus } from './common.js';

export const Kind = 'EXPORT_PATIENT_INFORMATION' as const;
export { ExportStatus as Status };
